import { CardList } from "@/components/CardList";
import { ReactSVG } from "react-svg";

export const BenefitsListExtended = ({ list }) => {
  if (!list) return null;

  return (
    <div className="benefits-list-extended">
      <CardList
        cardItems={list.map((item) => ({
          icon: (
            <ReactSVG
              className="button__icon"
              src={item.icon as string}
            />
          ),
          title: item.title,
          subtitle: item.subtitle,
          component: item.component,
          label: item.label,
        }))}
        showCarrousel={false}
      />
    </div>
  );
};
